var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./AwardsADGEligiblePopup.jinja');
require('./AwardsADGEligiblePopup.less');

var AwardsADGWinnersList = require('front/components/AwardsADGWinnersList/AwardsADGWinnersList');


module.exports = BasePopup.extend({

    template: template,

    events: _.extend({
        'click .AwardsADGEligiblePopup-switchersItem': 'onCategoryClick',
        'click .AwardsADGEligiblePopup-categorySelectorDropdownItem': 'onCategoryMobileClick',
        'click .AwardsADGEligiblePopup-categorySelector': 'toggleCategoryDropdown'
    }, BasePopup.prototype.baseEvents),


    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'AwardsADGWinnersList': {selector: '.AwardsADGWinnersList', viewConstructor: AwardsADGWinnersList}
    },


    apiUrl: function () {
        return Urls['submissions:api:eligible'](this.category, 'json');
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onBodyClick');

        this.showLoader = true;

        this.category = this.options.category;

        BasePopup.prototype.initialize.call(this, options);
    },

    renderData: function () {

        //to distinguish popup shown on adg awards site from the same popup shown on submissions minisite
        //backend views has the same options
        this.data.parent = this.options.parent;

        return {
            popup: this.data || {}
        };
    },


    toggleCategoryDropdown: function (e) {
        var $selector = this.$('.AwardsADGEligiblePopup-categorySelector');
        var dropdownClass = '.AwardsADGEligiblePopup-categorySelectorDropdown';
        var activeModifier = 'AwardsADGEligiblePopup-categorySelector--active';

        if ($(e.target).closest(dropdownClass).length) return;

        if ($selector.hasClass(activeModifier)) {
            this.closeCategoryDropdown();
        } else {
            $selector.find(dropdownClass).slideDown(200);
            $selector.addClass(activeModifier);
            $('body').on('click', this.onBodyClick);
        }
    },


    closeCategoryDropdown: function () {
        var $selector = this.$('.AwardsADGEligiblePopup-categorySelector');
        var dropdownClass = '.AwardsADGEligiblePopup-categorySelectorDropdown';
        var activeModifier = 'AwardsADGEligiblePopup-categorySelector--active';

        $selector.find(dropdownClass).slideUp(200);
        $selector.removeClass(activeModifier);
        $('body').off('click', this.onBodyClick);
    },


    onBodyClick: function (e) {
        if ($(e.target).closest('.AwardsADGEligiblePopup-categorySelector').length) return;

        this.closeCategoryDropdown();
    },


    onCategoryMobileClick: function (e) {
        var $category = $(e.currentTarget);
        var ind = $category.attr('data-index');

        this.$('.AwardsADGEligiblePopup-categorySelectorText span').text($category.text());

        this.$('.AwardsADGEligiblePopup-categorySelectorDropdownItem').removeClass('AwardsADGEligiblePopup-categorySelectorDropdownItem--active');
        this.$('.AwardsADGEligiblePopup-categorySelectorDropdownItem[data-index="' + ind + '"]').addClass('AwardsADGEligiblePopup-categorySelectorDropdownItem--active');

        this.$('.AwardsADGEligiblePopup-list').removeClass('AwardsADGEligiblePopup-list--active');
        this.$('.AwardsADGEligiblePopup-list[data-index="' + ind + '"]').addClass('AwardsADGEligiblePopup-list--active');

        this.closeCategoryDropdown();
    },


    onCategoryClick: function (e) {
        var $category = $(e.currentTarget);
        var ind = $category.attr('data-index');

        this.$('.AwardsADGEligiblePopup-switchersItem').removeClass('AwardsADGEligiblePopup-switchersItem--active');
        this.$('.AwardsADGEligiblePopup-switchersItem[data-index="' + ind + '"]').addClass('AwardsADGEligiblePopup-switchersItem--active');

        this.$('.AwardsADGEligiblePopup-list').removeClass('AwardsADGEligiblePopup-list--active');
        this.$('.AwardsADGEligiblePopup-list[data-index="' + ind + '"]').addClass('AwardsADGEligiblePopup-list--active');
    },


    onPrintClick: function () {
        if (this.disablePrint) return;

        var printContent = this.$('.AwardsADGEligiblePopup-content')[0];
        var headContent = $('head')[0];
        var windowUrl = 'about:blank';
        var uniqueName = new Date();
        var windowName = 'Print ' + this.$('.AwardsADGEligiblePopup-caption').text();

        var printWindow = window.open(windowUrl, windowName, 'left=0,top=0,width=1024,height=600');

        printWindow.document.write(headContent.innerHTML);
        printWindow.document.write(printContent.innerHTML);
        printWindow.document.documentElement.style.fontSize = '300px';
        printWindow.document.close();
        printWindow.focus();

        this.disablePrint = true;

        setTimeout(function () {
            printWindow.print();
            printWindow.close();
            delete this.disablePrint;
        }.bind(this), 1500);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/AwardsADGEligiblePopup/AwardsADGEligiblePopup.js
// module id = 255
// module chunks = 0